<div class="w-full">
  <div class="container mx-auto mt-4 px-4">
    <h4 class="text-lg font-bold">What to expect</h4>
    <hr class="my-2 border-gray-300" />

    <div class="mb-3 flex items-center gap-3">
      <svg class="shrink-0" mib-desktop-icon></svg>
      <p class="m-0">
        <strong>Test the hardware & software setup on the end-point</strong> (Microphone, Browser)
      </p>
    </div>

    <div class="mb-3 flex items-center gap-3">
      <svg class="shrink-0" mib-sat-icon></svg>
      <p class="m-0">
        <strong>Test connectivity to all Medinbox services</strong>
      </p>
    </div>

    <div class="mb-3 flex items-center gap-3">
      <svg class="shrink-0" mib-barchart-icon></svg>
      <p class="m-0">
        <strong>Collect bitrate and packet loss statistics</strong>
      </p>
    </div>

    <p class="text-sm text-gray-500 mt-3">
      In order to get results, this test will last for 30 seconds.
    </p>
  </div>
</div>
